import React, { Component } from "react";

import Dashboard from "../pages/Dashboard/index";
import Requisitions from "../pages/Recruitment/Requisitions";
import Login from "pages/AuthenticationInner/Login";
import Customers from "pages/Customer/Customers";
import AllRequisitions from "pages/Recruitment/AllRequisitions";
import Users from "pages/UserManagement/Users";
import AddUser from "pages/UserManagement/AddUser";
import AddRole from "pages/UserManagement/AddRole";
import Role from "pages/UserManagement/Role";
import Modules from "pages/UserManagement/Modules/Modules";
import AddModule from "pages/UserManagement/Modules/AddModule";
import AddCustomer from "pages/Customer/AddCustomer";
import AddContract from "pages/Contracts/AddContract";
import Contracts from "pages/Contracts/Contracts";
import Contacts from "pages/Contacts/Contacts";
import AddContact from "pages/Contacts/AddContact";
import Projects from "pages/Projects/Projects";
import AddProject from "pages/Projects/AddProject";
import AddShippingBilling from "pages/Customer/AddShippingBilling";
import AddSubscription from "pages/Subscription/AddSubscription";
import Employees from "pages/HumanResources/Employees/Employees";
import AddEmployee from "pages/HumanResources/Employees/AddEmployee";
import Assignments from "pages/Assignments/Assignment";
import AddAssignment from "pages/Assignments/AddAssignment";
import InvoiceLanding from "pages/Invoices";
import NewInvoice from "pages/Invoices/newinvoice";
import AddTimesheet from "pages/Timesheets/AddTimesheet";
import Timesheets from "pages/Timesheets/TimeSheets";
import Logout from "pages/AuthenticationInner/Logout";
import UserProfile from "pages/AuthenticationInner/user-profile";
// import { components } from "react-select";
import ViewCustomer from "pages/Customer/ViewCustomer";
import ViewShippingBilling from "pages/Customer/ViewShippingBilling";
import ViewProject from "pages/Projects/ViewProject";
import ViewUser from "pages/UserManagement/ViewUser";
import ViewEmployee from "pages/HumanResources/Employees/ViewEmployee";
import ViewAssignment from "pages/Assignments/ViewAssignment";
import ViewTimeSheet from "pages/Timesheets/ViewTimesheet";
import Payment from "pages/Billing/Payment/Payment";
import AddPayment from "pages/Billing/Payment/AddPayment";
import { ViewPayment } from "pages/Billing/Payment/ViewPayment";
import Receivables from "pages/Billing/Receivables/Receivables";
import AddReceivables from "pages/Billing/Receivables/AddReceivables";
import ViewReceivables from "pages/Billing/Receivables/ViewReceivables";
import Subscription from "pages/Subscription/Subscription";
import ViewSubscription from "pages/Subscription/ViewSubscription";
import ViewInvoice from "pages/Invoices/ViewInvoice";
import Tickets from "pages/Ticket/Tickets";
import AddTicket from "pages/Ticket/AddTicket";
import ViewTicket from "pages/Ticket/ViewTicket";

import Vendors from "pages/Vendors/Vendors";
// import AddCandidates from "pages/Recruitment/AddCandidates";
import JobPostOverview from "pages/Recruitment/JobPostOverview";
import NewCandidates from "pages/Recruitment/NewCandidates";
// import RecruitmentDashboard from "pages/Recruitment/RecruitmentDashboard";
import ViewJobPostings from "pages/Recruitment/ViewJobPostings";
import SubmittedCandidates from "pages/Recruitment/SubmittedCandidates";
import CandidateProgress from "pages/Recruitment/CandidateProgress";
import ExistingCandidates from "pages/Recruitment/ExistingCandidates";

import Template from "pages/Recruitment/Template";
import NewTemplate from "pages/Recruitment/NewTemplate";
// import NewCandidates from "pages/Recruitment/NewCandidates";
import JobPostings from "pages/Recruitment/JobPostings";
import JobDetails from "pages/Recruitment/JobDetails";
import Interviews from "pages/Recruitment/Interviews";
import ExtingTemplate from "pages/Recruitment/ExistingTemplate";
import ViewCandidateProfile from "pages/Recruitment/JobPosting/ViewCandidateProfile";
import ResourcePool from "pages/Recruitment/Referees/ResoursePool";

import AddCertificate from "pages/Certifications/AddCertificate";
import Certificates from "pages/Certifications/Certificates";
// import ViewInterviewCandidateProfile from "pages/Recruitment/ViewInterviewCandidateProfile";
import ViewCertificate from "pages/Certifications/ViewCertificate";
import AddNewTemplate from "pages/Recruitment/AddTemplete";
import RecruitmentDashboard from "pages/Recruitment/RecruitmentDashboard";
import ViewTemplate from "pages/Recruitment/Template/ViewTemplate";
import AddVendor from "pages/Vendors/AddVendor";
import CreateNewJob from "pages/Recruitment/CreateNewJob";
import Existingnewjob from "pages/Recruitment/Existingnewjob";

import VendorDashboard from "pages/Recruitment/Vendors/VendorDashboard";
import VendorJobs from "pages/Recruitment/Vendors/VendorJobs";
import VendorProfile from "pages/Recruitment/Vendors/VendorProfile";
import ViewJobPost from "pages/Recruitment/Vendors/ViewJobPost";
import SubmittedCandidate from "pages/Recruitment/Vendors/SubmittedCandidate";
import AddCandidate from "pages/Recruitment/Vendors/AddCandidate";
import AddNewCandidate from "pages/Recruitment/AddNewCandidate";
import Candidates from "pages/Recruitment/Candidates/Candidates";
import AddNewCandidates from "pages/Recruitment/Candidates/AddNewCandidates";
import ViewCandidateProgress from "pages/Recruitment/Candidates/ViewCandidateProgress";
import ViewCandidateTimeLine from "pages/Recruitment/Candidates/ViewCandidateTimeLine";
// import ViewCandidateProgress from "pages/Recruitment/Vendors/ViewCandidateProgress";
import ExistingCandidateProgress from "pages/Recruitment/ExistingCandidateProgress";
import AdminTimesheets from "pages/Timesheets/AdminTimeSheet";
import ViewVendor from "pages/Vendors/ViewVendor";
import ForgotPassword from "pages/AuthenticationInner/ForgotPassword";
import ResetPassword from "pages/AuthenticationInner/ResetPassword";
import ViewVendorShippingBilling from "pages/Vendors/ViewVendorShippingBilling";
import AddVendorShippingBilling from "pages/Vendors/AddVendorShippingBilling";
import ViewContact from "pages/Contacts/ViewContact";

const userRoutes = [
  { path: "/", component: <Dashboard /> },

  { path: "/users", component: <Users /> },

  { path: "/add-role/:roleId?", component: <AddRole /> },
  { path: "/role", component: <Role /> },

  { path: "/modules", component: <Modules /> },
  { path: "/add-module", component: <AddModule /> },

  { path: "/add-user/:userId?", component: <AddUser /> },
  { path: "/view-user/:userId", component: <ViewUser /> },

  { path: "/customers", component: <Customers /> },
  { path: "/add-customer/:customerId?", component: <AddCustomer /> },
  { path: "/view-customer/:customerId", component: <ViewCustomer /> },
  {
    path: "/addShippingBilling/:customerId",
    component: <AddShippingBilling />,
  },
  {
    path: "/view-ShippingBilling/:customerId",
    component: <ViewShippingBilling />,
  },


  //vendor
   { path: "/add-vendor/:vendorId?", component: <AddVendor /> },
  { path: "/vendors", component: <Vendors /> },
  {path:"/view-vendor/:vendorId",component:<ViewVendor/>},
  {path:"/view-vendor-shipping-billing/:vendorId",component:<ViewVendorShippingBilling/>},
 {path:"/addVendorShippingBilling/:vendorId?",component:<AddVendorShippingBilling/>},

  { path: "/contracts", component: <Contracts /> },
  { path: "/add-contract", component: <AddContract /> },

  { path: "/contacts", component: <Contacts/> },
  { path: "/add-contact/:id?", component: <AddContact /> },
  {path:"/contacts/view/:id?",component:<ViewContact/>},

  { path: "/projects", component: <Projects /> },
  { path: "/add-project/:projId?", component: <AddProject /> },
  { path: "/view-project/:projId?", component: <ViewProject /> },

  //assignments
  { path: "/assignments", component: <Assignments /> },
  { path: "/add-assignment/:AssignId?", component: <AddAssignment /> },
  { path: "/view-assignment/:AssignId?", component: <ViewAssignment /> },

  //timesheet
  { path: "/add-timesheet/:timeSheetId?", component: <AddTimesheet /> },
  { path: "/view-timesheet/:timeSheetId?", component: <ViewTimeSheet /> },
  { path: "/timesheets", component: <Timesheets /> },
  {path: "/admin-timesheet",component:<AdminTimesheets/>},

  { path: "/Subscription", component: <Subscription /> }, 
  { path: "/add-subscription/:id?", component: <AddSubscription /> },
  { path: "/view-subscription/:id?", component: <ViewSubscription /> },

  //Requisitions page
  { path: "/Requisitions", component: <Requisitions /> },

  { path: "/AllRequisitions", component: <AllRequisitions /> },

  // Employee routes
  { path: "/employees", component: <Employees /> },
  { path: "/add-employee/:empId?", component: <AddEmployee /> },
  { path: "/view-employee/:empId?", component: <ViewEmployee /> },

  //Billing
  { path: "/payments", component: <Payment /> },
  { path: "/add-payment/:id?", component: <AddPayment /> },
  { path: "/view-payment/:id?", component: <ViewPayment /> },

  { path: "/receivables", component: <Receivables /> },
  { path: "/add-receivables/:id?", component: <AddReceivables /> },
  { path: "/view-receivables/:id?", component: <ViewReceivables /> },
  { path: "/tickets", component: <Tickets/> },
  { path: "/add-ticket/:id?", component: <AddTicket/> },
  { path: "/view-ticket/:id?", component: <ViewTicket/>},


  //Recruitment 
  {path:"/view-job-postings" , component:<ViewJobPostings/>},
  // {path:"/job-post-overview" , component:<JobPostOverview/>},
  // {path:"/submitted-candidates" , component:<SubmittedCandidates/>},
  {path:"/view-candidate-progress" , component:<CandidateProgress/>},
  {path:"/existing-candidates" , component:<ExistingCandidates/>},
  {path:"/new-candidates" , component:<NewCandidates/>},
  {path:"/template" , component:<Template/>},
  {path:"/add-new-template" , component:<NewTemplate/>},
  {path:"/recuirement-dashboard",component:<RecruitmentDashboard/>},

  {path:"/job-postings" , component:<JobPostings/>},
  { path: "/job-details/:id?", component: <JobDetails /> },
  {path:"/interviews",component:<Interviews/>},
  {path:"/existing-template",component:<ExtingTemplate/>},

  {path:"/view-candidate-profile/:candidateId?",component:<ViewCandidateProfile/>},
  {path:"/add-new-templete/:templateId?",component:<AddNewTemplate/>},
  {path:"/view-templete/:tId",component:<ViewTemplate/>},
  {path:"/resource-pool",component:<ResourcePool/>},
  {path:"/create-new-job/:id?",component:<CreateNewJob/>},
  {path:"/existing-new-job",component:<Existingnewjob/>},
  {path:"/add-new-candidates",component:<AddNewCandidates/>},
  
  //recuirement-vendor
 {path:"/recuirement-vendor",component:<VendorDashboard/>},
 {path:"/vendor-dashboard",component:<VendorDashboard/>},
 {path:"/vendor-jobs",component:<VendorJobs/>},
 {path:"/view-job/:jobId",component: <ViewJobPost/>},
 {path:"/submitted-candidate/:id",component:<SubmittedCandidate/>},
 {path:"/candidate",component:<Candidates/>},
 {path:"/vendor-profile",component:<VendorProfile/>},
 {path:"/add-candidate/:jobId",component:<AddCandidate/>},
 {path:"/add-newcandidate/:id",component:<AddNewCandidate/>},
 {path:"//view-candidate/:candidateId",component:<ViewCandidateProgress/>},
 {path:"/view-candidate-progress-timeline/:candidateId?",component:<ViewCandidateTimeLine/>},
 


 {path:"/add-newcandidate/:jobId",component:<AddNewCandidate/>},
 {path:"/view-candidateprogerss/:jobId",component:<ViewCandidateProgress/>},
 {path:"/existing-candidateprogerss/:jobId",component:<ExistingCandidateProgress/>},



// Certificates
{path:"/certificates" , component:<Certificates/>},
{path:"/add-new-certificates/:certificateId?" , component:<AddCertificate/>},
{path:"/view-certificates/:certificateId?" , component:<ViewCertificate/>},
  

  //Invoice
  { path: "/invoice", component: <InvoiceLanding /> },
  { path: "/add-invoice/:invoiceId?", component: <NewInvoice /> },
  { path: "/view-invoice/:invoiceId", component: <ViewInvoice /> },

  //Vendors
  { path: "/add-vendors", component: <AddVendor /> },
  

  // //profile
  { path: "/profile", component: <UserProfile /> },

  // logout
  { path: "/logout", component: <Logout /> },

  // wildcard page
  { path: "*", component: <Dashboard /> },
];

const authRoutes = [{ path: "/login", component: <Login /> },
 { path: "/forgot-password", component: <ForgotPassword /> },
 { path: "/reset-password", component: <ResetPassword /> },
];

export { userRoutes, authRoutes };